<template>
  <CardGraphicTop
    class="card"
    img-alt="Nouvelle famille"
    img-src="/images/family/member-new.svg"
    :show-controls="true"
    :close-click-outside="true"
    :style-image="{ marginTop: '-3.2rem' }"
    :style-content="{ marginTop: '3.3rem' }"
  >
    <template #title>
      Félicitations <icon name="fluent-emoji:fire" />
    </template>

    <p>
      Bravo , tu viens de rejoindre
      <strong>ta famille</strong> ! Profite de ton abonnement
      <strong>NOMAD+</strong> dès maintenant !
    </p>

    <template #footer>
      <EffectParticles />
      <ButtonBase
        to="/nomad"
        :rounded="true"
        theme="secondary"
        stroke="n"
        class="button"
        size="small"
        @click="() => dialog.close()"
      >
        Je découvre !
      </ButtonBase>
    </template>
  </CardGraphicTop>
</template>

<script setup lang="ts">
interface Props {
  member: FamilyMember;
}
defineProps({
  member: null
});
const dialog = useDialogStore();
</script>

<style lang="scss" scoped>
.card {
  justify-self: center;
  align-self: center;
  width: 32rem;
  box-shadow: rgb(0 0 0 / 16%) 0 10px 36px 0, rgb(0 0 0 / 6%) 0 0 0 1px;
  @include above('l') {
    width: 40rem;
  }
}
</style>
